export default __webpack_public_path__ + "static/media/product.cfacbbaa.svg";